import React, { useState } from 'react';
import { PlusIcon, TrashIcon } from 'lucide-react';
const PartnerInfoStep = ({
  onNext,
  onPrev
}) => {
  const [hasPartners, setHasPartners] = useState(false);
  const [partners, setPartners] = useState([{
    name: '',
    email: '',
    role: ''
  }]);
  const handleSubmit = e => {
    e.preventDefault();
    onNext();
  };
  const addPartner = () => {
    setPartners([...partners, {
      name: '',
      email: '',
      role: ''
    }]);
  };
  const removePartner = index => {
    const updatedPartners = [...partners];
    updatedPartners.splice(index, 1);
    setPartners(updatedPartners);
  };
  const updatePartner = (index, field, value) => {
    const updatedPartners = [...partners];
    updatedPartners[index][field] = value;
    setPartners(updatedPartners);
  };
  return <div data-id="element-735">
      <h2 className="text-xl font-semibold mb-6" data-id="element-736">Partner Information</h2>
      <form onSubmit={handleSubmit} data-id="element-737">
        <div className="space-y-6" data-id="element-738">
          <div data-id="element-739">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-740">
              Does your business have partners?
            </label>
            <div className="flex space-x-4" data-id="element-741">
              <label className="flex items-center" data-id="element-742">
                <input type="radio" name="hasPartners" value="yes" checked={hasPartners} onChange={() => setHasPartners(true)} className="h-4 w-4 text-blue-600 focus:ring-blue-500" data-id="element-743" />
                <span className="ml-2" data-id="element-744">Yes</span>
              </label>
              <label className="flex items-center" data-id="element-745">
                <input type="radio" name="hasPartners" value="no" checked={!hasPartners} onChange={() => setHasPartners(false)} className="h-4 w-4 text-blue-600 focus:ring-blue-500" data-id="element-746" />
                <span className="ml-2" data-id="element-747">No</span>
              </label>
            </div>
          </div>
          {hasPartners && <div className="space-y-4" data-id="element-748">
              <p className="text-sm text-gray-500" data-id="element-749">
                Please provide information about your business partners
              </p>
              {partners.map((partner, index) => <div key={index} className="p-4 border border-gray-200 rounded-md" data-id="element-750">
                  <div className="flex justify-between items-center mb-3" data-id="element-751">
                    <h3 className="font-medium" data-id="element-752">Partner {index + 1}</h3>
                    {partners.length > 1 && <button type="button" onClick={() => removePartner(index)} className="text-red-500 hover:text-red-700" data-id="element-753">
                        <TrashIcon className="h-5 w-5" data-id="element-754" />
                      </button>}
                  </div>
                  <div className="space-y-3" data-id="element-755">
                    <div data-id="element-756">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-757">
                        Partner Name
                      </label>
                      <input type="text" value={partner.name} onChange={e => updatePartner(index, 'name', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter partner name" required={hasPartners} data-id="element-758" />
                    </div>
                    <div data-id="element-759">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-760">
                        Partner Email
                      </label>
                      <input type="email" value={partner.email} onChange={e => updatePartner(index, 'email', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter partner email" required={hasPartners} data-id="element-761" />
                    </div>
                    <div data-id="element-762">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-763">
                        Partner Role
                      </label>
                      <input type="text" value={partner.role} onChange={e => updatePartner(index, 'role', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter partner role" required={hasPartners} data-id="element-764" />
                    </div>
                  </div>
                </div>)}
              <button type="button" onClick={addPartner} className="flex items-center text-blue-600 hover:text-blue-800" data-id="element-765">
                <PlusIcon className="h-5 w-5 mr-1" data-id="element-766" />
                Add Another Partner
              </button>
            </div>}
          <div className="pt-4 flex justify-between" data-id="element-767">
            <button type="button" onClick={onPrev} className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-768">
              Back
            </button>
            <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-769">
              Continue to Document Upload
            </button>
          </div>
        </div>
      </form>
    </div>;
};
export default PartnerInfoStep;